const detailLabels: Record<string, string> = {
  kolya_percent: "Доля Коли, %",
  vlad_percent: "Доля Влада, %",
  pending: "Предложенные доли",
  active: "Действующие доли: Коля / Влад",
  approved_proposal: "Согласованное предложение",
  approvals: "Подтвердили",
  approval_users: "Аккаунты подтвердивших",
  proposed_by: "Предложил",
  proposed_at: "Дата предложения",
  revision: "Версия настроек",
  theme: "Тема",
  money_colors: "Цветовые акценты сумм",
  telegram_price: "Цена Telegram",
  avito_price: "Цена Авито",
  oskelly_price: "Цена Oskelly",
  reserved_amount: "Цена резерва",
  reserved_platform: "Площадка резерва",
  shipment_code: "Поставка",
  arrival_date: "Дата поступления",
  delivery_per_item: "Доставка на сумку",
  purchase_cost: "Закупка",
  investor: "Инвестор",
  status: "Статус",
  platform: "Площадка",
  gross_amount: "Продажа",
  other_costs: "Прочие расходы",
  delivery_cost: "Доставка",
  net_profit: "Прибыль",
  kolya_payout: "Коле с закупкой",
  vlad_payout: "Владу с закупкой",
  kolya_share_percent: "Доля Коли",
  vlad_share_percent: "Доля Влада",
  reason: "Причина",
  caption: "Описание",
  amount: "Сумма",
  description: "Описание",
  day: "Дата",
  category: "Категория",
  payer: "Оплатил",
  kolya: "Коля",
  vlad: "Влад",
  code: "Поставка",
  chosen_photos: "Выбранные фото",
  before: "Было",
  after: "Стало",
  owner_party: "Владелец средств",
  currency: "Валюта",
  name: "Название",
  value: "Значение",
};
export function auditValue(value: unknown): string {
  if (value == null || value === "") return "—";
  if (typeof value === "boolean") return value ? "Да" : "Нет";
  if (Array.isArray(value)) return value.map(auditValue).join(" · ");
  if (typeof value === "object")
    return Object.entries(value)
      .map(([key, item]) => `${detailLabels[key] || key}: ${auditValue(item)}`)
      .join(" · ");
  const text = String(value);
  const labels: Record<string, string> = {
    kolya: "Коля", vlad: "Влад", telegram: "Telegram", avito: "Авито", oskelly: "Oskelly", direct: "Частник",
    purchased: "Выкуплена", china_transit: "Едет на склад Китая", china_warehouse: "Склад Китая", in_transit: "В пути", moscow: "В Москве", processing: "Подготовка", ready: "Готова к размещению",
    light: "Светлая",
    dark: "Тёмная",
    new: "Новая",
    preparing: "Готовится",
    available: "В наличии",
    reserved: "Резерв",
    sold: "Продано",
    needs_reconciliation: "Проверить данные",
    pending_delivery: "Ожидает приёмки и доставки",
    settled: "Закрыт",
    active: "Активен",
    consumed: "Израсходован",
    voided: "Отменён",
    posted: "Проведён",
    draft: "Черновик",
    cash: "Наличные",
    wallet: "Кошелёк",
    bank: "Банковский счёт",
    exchange: "Обмен",
    alipay: "Alipay",
    revenue: "Выручка",
    profit: "Прибыль",
    business: "Бизнес",
    open: "Открыт",
  };
  return labels[text] || text;
}
